/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { Virtuoso } from "react-virtuoso";
import { useFontStyle } from "~/hook/useFontStyle";
import { useLanguageParams } from "~/hook/useLanguageParams";
import { ImageData } from "~/interface/commonImagesize-types";
import { getEventImageDate } from "~/lib/helperFuncation/formateDate";
import { getFormateTime } from "~/lib/helperFuncation/getFormateTime";
import { cn } from "~/lib/utils";
import { subEventMedia } from "~/routes/$lang.event-images.$url_slug._index";
import api from "~/utils/Interceptor";
import API_PATH from "~/utils/api-routes";
import { BLUR_HASH } from "~/utils/constant";
import ClientOnly from "../shared-components/ClentOnly";
import ImageWithSkeleton from "../shared-components/ImageWithSkeleton";
import LightGalleryWrapper from "../shared-components/LightGalleryWrapper";

interface EventImageCardProps {
  subEvent: any[];
  year: number;
  eventSlug: string;
}

interface SubEventMediaPreviewCardProps {
  subEventMedia: subEventMedia[];
  year: number;
  eventSlug: string;
  subEventId: number;
  subEventName: string;
  isServer: boolean;
}

export interface ImagedataType {
  id: number;
  disp_order: number;
  desc: string;
  type: string;
  img_url: string;
  img_aspect: string;
  img: ImageData | null;
  name: string;
}

const TimeLineViewEvent = ({ subEvent, year, eventSlug }: EventImageCardProps) => {
  const { medium } = useFontStyle();
  const [isServer, setIsServer] = useState(true);

  useEffect(() => {
    setIsServer(false);
  }, []);

  return (
    <ClientOnly
      fallback={subEvent.map(
        (event: any) =>
          event.tbl_event_media.length > 0 && (
            <div className="w-full flex flex-col justify-start items-start gap-2 pb-6 pl-5 relative " key={event.id}>
              <div className={cn("h-full w-[3px] absolute left-0 top-4 bg-textColor opacity-5", "bg-eventcardGradient opacity-100 h-full")}></div>
              <div className="size-[10px] rounded-full absolute top-3 left-[-3px] bg-textColor"></div>
              <div className="flex flex-col justify-start items-start gap-2">
                <h2 className={cn("max-md:text-16 text-[24px] text-textColor", medium)}>{event?.name}</h2>
                {event.from_time && (
                  <span className="text-16 text-primaryColor font-normal font-inter">
                    {getEventImageDate(event.date).month} {getEventImageDate(event.date).day}, {getFormateTime(event.from_time)}
                  </span>
                )}
              </div>
              <div className="w-full flex justify-end items-end mt-3 md:pl-[59px] sm:pl-[20px]">
                <SubEventMediaPreviewCard
                  subEventMedia={event.tbl_event_media}
                  year={year}
                  eventSlug={eventSlug}
                  subEventId={event.id}
                  subEventName={event.name}
                  isServer={isServer}
                />
              </div>
            </div>
          ),
      )}
    >
      <Virtuoso
        style={{ height: "100%", width: "100%" }}
        useWindowScroll
        increaseViewportBy={200}
        data={subEvent}
        itemContent={(i, event) => {
          return (
            event.tbl_event_media.length > 0 && (
              <div className="w-full flex flex-col justify-start items-start gap-2 pb-6 pl-5 relative" key={event.id}>
                <div className={cn("h-full w-[3px] absolute left-0 top-4 bg-textColor opacity-5", "bg-eventcardGradient opacity-100 h-full")}></div>
                <div className="size-[10px] rounded-full absolute top-3 left-[-3px] bg-textColor"></div>
                <div className="flex flex-col justify-start items-start gap-2">
                  <h2 className={cn("max-md:text-16 text-[24px] text-textColor", medium)}>{event?.name}</h2>
                  {event.from_time && (
                    <span className="text-16 text-primaryColor font-normal font-inter">
                      {getEventImageDate(event.date).month} {getEventImageDate(event.date).day}, {getFormateTime(event.from_time)}
                    </span>
                  )}
                </div>

                <div className="w-full flex justify-end items-end mt-3 md:pl-[59px] sm:pl-[20px]">
                  <SubEventMediaPreviewCard
                    subEventMedia={event.tbl_event_media}
                    year={year}
                    eventSlug={eventSlug}
                    subEventId={event.id}
                    subEventName={event.name}
                    isServer={false}
                  />
                </div>
              </div>
            )
          );
        }}
        components={{
          Footer: () => (
            <div className="w-full flex justify-center items-center">
              <p className="text-[32px] text-textColor font-abcArizonaFlareVariable">{year}</p>
            </div>
          ),
        }}
      />
    </ClientOnly>
  );
};

const SubEventMediaPreviewCard = ({ subEventMedia, year, eventSlug, subEventId, subEventName, isServer }: SubEventMediaPreviewCardProps) => {
  const lang = useLanguageParams();
  const [eventImagesArray, setEventImagesArray] = useState<ImagedataType[]>([]);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null); // State to track clicked image index

  if (!subEventMedia || subEventMedia.length === 0) return null;
  const path = `/event-images/${eventSlug}/`;

  // Use only available images, no padding/duplicates
  const displayImages = subEventMedia.slice(0, 5);
  const firstImage = displayImages[0];
  const restImages = displayImages.slice(1);

  const handleOnImageClick = async (index: number) => {
    try {
      const Imagedata = await api.get(`${API_PATH.EVENT_MEDIA_LIST}/${subEventId}${lang === "gu" ? "?lang=gu" : ""}`);

      const hasData = Imagedata.status === 200 && Imagedata.data.data.sub_event && Imagedata.data.data.sub_event.tbl_event_media.length > 0;

      if (hasData) {
        const images = Imagedata.data.data.sub_event.tbl_event_media;
        setEventImagesArray(images); // only set images
        setLightboxIndex(index);
      }
    } catch (error) {
      console.log("Error while fetching event Images: ", error);
    }
  };

  return (
    <div className="w-full mx-auto">
      {/* Desktop & Tablet Layout */}
      <div className="max-sm:hidden">
        {displayImages.length === 1 ? (
          // Single image - full width with rounded corners
          <div className="relative w-[50%] aspect-[16/9] cursor-pointer" onClick={() => handleOnImageClick(0)}>
            <ImageWithSkeleton
              url={
                firstImage.img
                  ? {
                      small: firstImage.img.s.url,
                      medium: firstImage.img.m.url,
                      large: firstImage.img.l.url,
                      hd: firstImage.img.hd.url,
                      original: firstImage.img.og.url,
                    }
                  : {
                      small: firstImage.img_url,
                      medium: firstImage.img_url,
                      large: firstImage.img_url,
                      hd: firstImage.img_url,
                      original: firstImage.img_url,
                    }
              }
              alt={subEventName}
              blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
              className="w-full h-full object-cover select-none"
              roundedClass="rounded-xl"
              isPreloaded={isServer}
            />
          </div>
        ) : displayImages.length === 2 ? (
          // Two images - side by side
          <div className="grid grid-cols-2 gap-[1px] cursor-pointer">
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
              <ImageWithSkeleton
                url={
                  firstImage.img
                    ? {
                        small: firstImage.img.s.url,
                        medium: firstImage.img.m.url,
                        large: firstImage.img.l.url,
                        hd: firstImage.img.hd.url,
                        original: firstImage.img.og.url,
                      }
                    : {
                        small: firstImage.img_url,
                        medium: firstImage.img_url,
                        large: firstImage.img_url,
                        hd: firstImage.img_url,
                        original: firstImage.img_url,
                      }
                }
                alt={subEventName}
                blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                className="w-full h-full object-cover"
                roundedClass="rounded-l-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
              <ImageWithSkeleton
                url={
                  restImages[0].img
                    ? {
                        small: restImages[0].img.s.url,
                        medium: restImages[0].img.m.url,
                        large: restImages[0].img.l.url,
                        hd: restImages[0].img.hd.url,
                        original: restImages[0].img.og.url,
                      }
                    : {
                        small: restImages[0].img_url,
                        medium: restImages[0].img_url,
                        large: restImages[0].img_url,
                        hd: restImages[0].img_url,
                        original: restImages[0].img_url,
                      }
                }
                blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-r-xl"
                isPreloaded={isServer}
              />
            </div>
          </div>
        ) : displayImages.length === 3 ? (
          // Three images - one large, two stacked on right
          <div className="grid grid-cols-3 gap-[1px] cursor-pointer">
            <div className="relative aspect-[16/9] row-span-2" onClick={() => handleOnImageClick(0)}>
              <ImageWithSkeleton
                url={
                  firstImage.img
                    ? {
                        small: firstImage.img.s.url,
                        medium: firstImage.img.m.url,
                        large: firstImage.img.l.url,
                        hd: firstImage.img.hd.url,
                        original: firstImage.img.og.url,
                      }
                    : {
                        small: firstImage.img_url,
                        medium: firstImage.img_url,
                        large: firstImage.img_url,
                        hd: firstImage.img_url,
                        original: firstImage.img_url,
                      }
                }
                alt={subEventName}
                blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                className="w-full h-full object-cover"
                roundedClass="rounded-l-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
              <ImageWithSkeleton
                url={
                  restImages[0].img
                    ? {
                        small: restImages[0].img.s.url,
                        medium: restImages[0].img.m.url,
                        large: restImages[0].img.l.url,
                        hd: restImages[0].img.hd.url,
                        original: restImages[0].img.og.url,
                      }
                    : {
                        small: restImages[0].img_url,
                        medium: restImages[0].img_url,
                        large: restImages[0].img_url,
                        hd: restImages[0].img_url,
                        original: restImages[0].img_url,
                      }
                }
                blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-tr-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(2)}>
              <ImageWithSkeleton
                url={
                  restImages[1].img
                    ? {
                        small: restImages[1].img.s.url,
                        medium: restImages[1].img.m.url,
                        large: restImages[1].img.l.url,
                        hd: restImages[1].img.hd.url,
                        original: restImages[1].img.og.url,
                      }
                    : {
                        small: restImages[1].img_url,
                        medium: restImages[1].img_url,
                        large: restImages[1].img_url,
                        hd: restImages[1].img_url,
                        original: restImages[1].img_url,
                      }
                }
                blur_hash={restImages[1].img ? restImages[1].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-br-xl rounded-tr-xl"
                isPreloaded={isServer}
              />
              {/* <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-br-xl rounded-tr-xl">
                <span className="text-white font-semibold text-lg">View All</span>
              </div> */}
            </div>
          </div>
        ) : displayImages.length === 4 ? (
          // Four images - 2x2 grid filling all space
          <div className="w-[50%] grid grid-cols-2  gap-[1px] cursor-pointer">
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
              <ImageWithSkeleton
                url={
                  firstImage.img
                    ? {
                        small: firstImage.img.s.url,
                        medium: firstImage.img.m.url,
                        large: firstImage.img.l.url,
                        hd: firstImage.img.hd.url,
                        original: firstImage.img.og.url,
                      }
                    : {
                        small: firstImage.img_url,
                        medium: firstImage.img_url,
                        large: firstImage.img_url,
                        hd: firstImage.img_url,
                        original: firstImage.img_url,
                      }
                }
                alt={subEventName}
                blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                className="w-full h-full object-cover"
                roundedClass="rounded-tl-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
              <ImageWithSkeleton
                url={
                  restImages[0].img
                    ? {
                        small: restImages[0].img.s.url,
                        medium: restImages[0].img.m.url,
                        large: restImages[0].img.l.url,
                        hd: restImages[0].img.hd.url,
                        original: restImages[0].img.og.url,
                      }
                    : {
                        small: restImages[0].img_url,
                        medium: restImages[0].img_url,
                        large: restImages[0].img_url,
                        hd: restImages[0].img_url,
                        original: restImages[0].img_url,
                      }
                }
                blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-tr-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(2)}>
              <ImageWithSkeleton
                url={
                  restImages[1].img
                    ? {
                        small: restImages[1].img.s.url,
                        medium: restImages[1].img.m.url,
                        large: restImages[1].img.l.url,
                        hd: restImages[1].img.hd.url,
                        original: restImages[1].img.og.url,
                      }
                    : {
                        small: restImages[1].img_url,
                        medium: restImages[1].img_url,
                        large: restImages[1].img_url,
                        hd: restImages[1].img_url,
                        original: restImages[1].img_url,
                      }
                }
                blur_hash={restImages[1].img ? restImages[1].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-bl-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(3)}>
              <ImageWithSkeleton
                url={
                  restImages[2].img
                    ? {
                        small: restImages[2].img.s.url,
                        medium: restImages[2].img.m.url,
                        large: restImages[2].img.l.url,
                        hd: restImages[2].img.hd.url,
                        original: restImages[2].img.og.url,
                      }
                    : {
                        small: restImages[2].img_url,
                        medium: restImages[2].img_url,
                        large: restImages[2].img_url,
                        hd: restImages[2].img_url,
                        original: restImages[2].img_url,
                      }
                }
                blur_hash={restImages[2].img ? restImages[2].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-br-xl"
                isPreloaded={isServer}
              />
            </div>
          </div>
        ) : (
          // Five or more images - standard grid layout
          <div className="grid grid-cols-4 gap-[1px] cursor-pointer">
            <div className="relative col-span-2 aspect-[16/9] h-full overflow-hidden" onClick={() => handleOnImageClick(0)}>
              <ImageWithSkeleton
                url={
                  firstImage.img
                    ? {
                        small: firstImage.img.s.url,
                        medium: firstImage.img.m.url,
                        large: firstImage.img.l.url,
                        hd: firstImage.img.hd.url,
                        original: firstImage.img.og.url,
                      }
                    : {
                        small: firstImage.img_url,
                        medium: firstImage.img_url,
                        large: firstImage.img_url,
                        hd: firstImage.img_url,
                        original: firstImage.img_url,
                      }
                }
                alt={subEventName}
                blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                className="w-full h-full object-cover"
                roundedClass="rounded-l-xl"
                isPreloaded={isServer}
              />
            </div>

            <div className="col-span-2 grid grid-cols-2 gap-[1px] aspect-[16/9]">
              {restImages.map((item, index) => (
                <div key={index} className={cn("relative aspect-[16/9]")} onClick={() => handleOnImageClick(index + 1)}>
                  <ImageWithSkeleton
                    url={
                      item.img
                        ? {
                            small: item.img.s.url,
                            medium: item.img.m.url,
                            large: item.img.l.url,
                            hd: item.img.hd.url,
                            original: item.img.og.url,
                          }
                        : {
                            small: item.img_url,
                            medium: item.img_url,
                            large: item.img_url,
                            hd: item.img_url,
                            original: item.img_url,
                          }
                    }
                    blur_hash={item.img ? item.img.bh : BLUR_HASH}
                    alt={subEventName}
                    width={item.img ? item.img.m.w : 800}
                    height={item.img ? item.img.m.h : 500}
                    className="w-full h-full object-cover"
                    roundedClass={cn(index === 1 && "rounded-tr-xl", index === 3 && "rounded-br-xl")}
                    isPreloaded={isServer}
                  />

                  {index === restImages.length - 1 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-br-xl">
                      <span className="text-white font-semibold text-lg">View All</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Mobile Layout */}
      <div className="hidden max-sm:block">
        {displayImages.length === 1 ? (
          // Single image - full width
          <div className="relative w-full aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
            <ImageWithSkeleton
              url={
                firstImage.img
                  ? {
                      small: firstImage.img.s.url,
                      medium: firstImage.img.m.url,
                      large: firstImage.img.l.url,
                      hd: firstImage.img.hd.url,
                      original: firstImage.img.og.url,
                    }
                  : {
                      small: firstImage.img_url,
                      medium: firstImage.img_url,
                      large: firstImage.img_url,
                      hd: firstImage.img_url,
                      original: firstImage.img_url,
                    }
              }
              blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
              alt={subEventName}
              className="w-full h-full object-cover"
              roundedClass="rounded-xl"
              isPreloaded={isServer}
            />
          </div>
        ) : displayImages.length === 2 ? (
          // Two images - side by side
          <div className="grid grid-cols-2 gap-[1px]">
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
              <ImageWithSkeleton
                url={
                  firstImage.img
                    ? {
                        small: firstImage.img.s.url,
                        medium: firstImage.img.m.url,
                        large: firstImage.img.l.url,
                        hd: firstImage.img.hd.url,
                        original: firstImage.img.og.url,
                      }
                    : {
                        small: firstImage.img_url,
                        medium: firstImage.img_url,
                        large: firstImage.img_url,
                        hd: firstImage.img_url,
                        original: firstImage.img_url,
                      }
                }
                blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-l-xl"
                isPreloaded={isServer}
              />
            </div>
            <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
              <ImageWithSkeleton
                url={
                  restImages[0].img
                    ? {
                        small: restImages[0].img.s.url,
                        medium: restImages[0].img.m.url,
                        large: restImages[0].img.l.url,
                        hd: restImages[0].img.hd.url,
                        original: restImages[0].img.og.url,
                      }
                    : {
                        small: restImages[0].img_url,
                        medium: restImages[0].img_url,
                        large: restImages[0].img_url,
                        hd: restImages[0].img_url,
                        original: restImages[0].img_url,
                      }
                }
                blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                alt={subEventName}
                className="w-full h-full object-cover"
                roundedClass="rounded-r-xl"
                isPreloaded={isServer}
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-r-xl">
                <span className="text-white font-semibold text-sm">View All</span>
              </div>
            </div>
          </div>
        ) : displayImages.length === 3 ? (
          // Three images - 2 on top, 1 on bottom
          <div className="space-y-[1px]">
            <div className="grid grid-cols-2 gap-[1px]">
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
                <ImageWithSkeleton
                  url={
                    firstImage.img
                      ? {
                          small: firstImage.img.s.url,
                          medium: firstImage.img.m.url,
                          large: firstImage.img.l.url,
                          hd: firstImage.img.hd.url,
                          original: firstImage.img.og.url,
                        }
                      : {
                          small: firstImage.img_url,
                          medium: firstImage.img_url,
                          large: firstImage.img_url,
                          hd: firstImage.img_url,
                          original: firstImage.img_url,
                        }
                  }
                  blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tl-xl"
                  isPreloaded={isServer}
                />
              </div>
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
                <ImageWithSkeleton
                  url={
                    restImages[0].img
                      ? {
                          small: restImages[0].img.s.url,
                          medium: restImages[0].img.m.url,
                          large: restImages[0].img.l.url,
                          hd: restImages[0].img.hd.url,
                          original: restImages[0].img.og.url,
                        }
                      : {
                          small: restImages[0].img_url,
                          medium: restImages[0].img_url,
                          large: restImages[0].img_url,
                          hd: restImages[0].img_url,
                          original: restImages[0].img_url,
                        }
                  }
                  blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tr-xl"
                  isPreloaded={isServer}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-[1px]">
              <div className="relative col-span-2  aspect-[16/9]" onClick={() => handleOnImageClick(2)}>
                <ImageWithSkeleton
                  url={
                    restImages[1].img
                      ? {
                          small: restImages[1].img.s.url,
                          medium: restImages[1].img.m.url,
                          large: restImages[1].img.l.url,
                          hd: restImages[1].img.hd.url,
                          original: restImages[1].img.og.url,
                        }
                      : {
                          small: restImages[1].img_url,
                          medium: restImages[1].img_url,
                          large: restImages[1].img_url,
                          hd: restImages[1].img_url,
                          original: restImages[1].img_url,
                        }
                  }
                  blur_hash={restImages[1].img ? restImages[1].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-bl-xl rounded-br-xl"
                  isPreloaded={isServer}
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-bl-xl rounded-br-xl">
                  <span className="text-white font-semibold text-sm">View All</span>
                </div>
              </div>
            </div>
          </div>
        ) : displayImages.length === 4 ? (
          // Four images - 2x2 grid
          <div className="space-y-[1px]">
            <div className="grid grid-cols-2 gap-[1px]">
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
                <ImageWithSkeleton
                  url={
                    firstImage.img
                      ? {
                          small: firstImage.img.s.url,
                          medium: firstImage.img.m.url,
                          large: firstImage.img.l.url,
                          hd: firstImage.img.hd.url,
                          original: firstImage.img.og.url,
                        }
                      : {
                          small: firstImage.img_url,
                          medium: firstImage.img_url,
                          large: firstImage.img_url,
                          hd: firstImage.img_url,
                          original: firstImage.img_url,
                        }
                  }
                  blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tl-xl"
                  isPreloaded={isServer}
                />
              </div>
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
                <ImageWithSkeleton
                  url={
                    restImages[0].img
                      ? {
                          small: restImages[0].img.s.url,
                          medium: restImages[0].img.m.url,
                          large: restImages[0].img.l.url,
                          hd: restImages[0].img.hd.url,
                          original: restImages[0].img.og.url,
                        }
                      : {
                          small: restImages[0].img_url,
                          medium: restImages[0].img_url,
                          large: restImages[0].img_url,
                          hd: restImages[0].img_url,
                          original: restImages[0].img_url,
                        }
                  }
                  blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tr-xl"
                  isPreloaded={isServer}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-[1px] ">
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(2)}>
                <ImageWithSkeleton
                  url={
                    restImages[1].img
                      ? {
                          small: restImages[1].img.s.url,
                          medium: restImages[1].img.m.url,
                          large: restImages[1].img.l.url,
                          hd: restImages[1].img.hd.url,
                          original: restImages[1].img.og.url,
                        }
                      : {
                          small: restImages[1].img_url,
                          medium: restImages[1].img_url,
                          large: restImages[1].img_url,
                          hd: restImages[1].img_url,
                          original: restImages[1].img_url,
                        }
                  }
                  blur_hash={restImages[1].img ? restImages[1].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-bl-xl"
                  isPreloaded={isServer}
                />
              </div>
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(3)}>
                <ImageWithSkeleton
                  url={
                    restImages[2].img
                      ? {
                          small: restImages[2].img.s.url,
                          medium: restImages[2].img.m.url,
                          large: restImages[2].img.l.url,
                          hd: restImages[2].img.hd.url,
                          original: restImages[2].img.og.url,
                        }
                      : {
                          small: restImages[2].img_url,
                          medium: restImages[2].img_url,
                          large: restImages[2].img_url,
                          hd: restImages[2].img_url,
                          original: restImages[2].img_url,
                        }
                  }
                  blur_hash={restImages[2].img ? restImages[2].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-br-xl"
                  isPreloaded={isServer}
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-br-xl">
                  <span className="text-white font-semibold text-sm">View All</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Five or more images - 2 on top, 3 on bottom
          <div className="space-y-[1px]">
            <div className="grid grid-cols-2 gap-[1px]">
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(0)}>
                <ImageWithSkeleton
                  url={
                    firstImage.img
                      ? {
                          small: firstImage.img.s.url,
                          medium: firstImage.img.m.url,
                          large: firstImage.img.l.url,
                          hd: firstImage.img.hd.url,
                          original: firstImage.img.og.url,
                        }
                      : {
                          small: firstImage.img_url,
                          medium: firstImage.img_url,
                          large: firstImage.img_url,
                          hd: firstImage.img_url,
                          original: firstImage.img_url,
                        }
                  }
                  blur_hash={firstImage.img ? firstImage.img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tl-xl"
                  isPreloaded={isServer}
                />
              </div>
              <div className="relative aspect-[16/9]" onClick={() => handleOnImageClick(1)}>
                <ImageWithSkeleton
                  url={
                    restImages[0].img
                      ? {
                          small: restImages[0].img.s.url,
                          medium: restImages[0].img.m.url,
                          large: restImages[0].img.l.url,
                          hd: restImages[0].img.hd.url,
                          original: restImages[0].img.og.url,
                        }
                      : {
                          small: restImages[0].img_url,
                          medium: restImages[0].img_url,
                          large: restImages[0].img_url,
                          hd: restImages[0].img_url,
                          original: restImages[0].img_url,
                        }
                  }
                  blur_hash={restImages[0].img ? restImages[0].img.bh : BLUR_HASH}
                  alt={subEventName}
                  className="w-full h-full object-cover"
                  roundedClass="rounded-tr-xl"
                  isPreloaded={isServer}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-[1px]">
              {restImages.slice(1, 4).map((item, index) => (
                <div
                  key={index}
                  className={cn("relative aspect-[16/9]", index === 0 && "rounded-bl-xl", index === 2 && "rounded-br-xl")}
                  onClick={() => handleOnImageClick(index + 2)}
                >
                  <ImageWithSkeleton
                    url={
                      item.img
                        ? {
                            small: item.img.s.url,
                            medium: item.img.m.url,
                            large: item.img.l.url,
                            hd: item.img.hd.url,
                            original: item.img.og.url,
                          }
                        : {
                            small: item.img_url,
                            medium: item.img_url,
                            large: item.img_url,
                            hd: item.img_url,
                            original: item.img_url,
                          }
                    }
                    blur_hash={item.img ? item.img.bh : BLUR_HASH}
                    alt={subEventName}
                    width={item.img ? item.img.m.w : 800}
                    height={item.img ? item.img.m.h : 500}
                    className="w-full h-full object-cover"
                    roundedClass={cn(index === 0 && "rounded-bl-xl", index === 2 && "rounded-br-xl")}
                    isPreloaded={isServer}
                  />

                  {index === 2 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-br-xl">
                      <span className="text-white font-semibold text-sm">View All</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* {eventImagesArray.length > 0 && ( */}
      <LightGalleryWrapper
        images={eventImagesArray.map((data) => {
          return {
            id: data.id,
            url: data.img
              ? {
                  original: data.img.og.url,
                  small: data.img.s.url,
                  medium: data.img.m.url,
                  large: data.img.l.url,
                  hd: data.img.hd.url,
                }
              : {
                  small: data.img_url,
                  medium: data.img_url,
                  large: data.img_url,
                  hd: data.img_url,
                  original: data.img_url,
                },
            photoName: data.name || subEventName,
            isPreloaded: isServer,
          };
        })}
        indexToOpen={lightboxIndex}
        setLightBoxIndex={(index: number | null) => {
          setLightboxIndex(index);
        }}
      />
      {/* )} */}
    </div>
  );
};

export default TimeLineViewEvent;
